import { SVS_CODE_LENGTH, SVS_CODE_INDICATOR } from 'lib/constants';

export const validateSvsCode = ({ value, callbackFn }) => {
  if (
    value?.length >= SVS_CODE_LENGTH &&
    value.substring(0, SVS_CODE_INDICATOR.length) === SVS_CODE_INDICATOR
  ) {
    callbackFn(true);
  } else {
    callbackFn(false);
  }
};
